import { render, staticRenderFns } from "./GasupRecord.vue?vue&type=template&id=a410afda&scoped=true&"
import script from "./GasupRecord.vue?vue&type=script&lang=js&"
export * from "./GasupRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a410afda",
  null
  
)

export default component.exports